import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { CcPaymentReportComponent } from './cc-payment-report/cc-payment-report.component';
import { ClassSummaryComponent } from './class-summary/class-summary.component';
import { ContentManagementComponent } from './content-management/content-management.component';
import { CustomerComponent } from './customer/customer.component';
import { DevicesComponent } from './devices/devices.component';
import { DriversComponent } from './drivers/drivers.component';
import { AddEmployeeComponent } from './employee/add-edit-employee/add-employee.component';
import { EmployeeComponent } from './employee/employee.component';
import { OrderComponent } from './order/order.component';
import { ReferralSummaryComponent } from './referral-summary/referral-summary.component';
import { TagReportComponent } from './tag-report/tag-report.component';
import { AuthGuard } from './user-management/Authorization/auth.guard';
import { UserManagementComponent } from './user-management/user-management.component';


const routes: Routes = [
  { path: '', component: UserManagementComponent },

  { path: 'Order', component: OrderComponent,canActivate: [AuthGuard] },
  { path: 'ClassSummaryReport', component : ClassSummaryComponent,canActivate: [AuthGuard]},
  { path: 'LotTaggingReport', component : TagReportComponent,canActivate: [AuthGuard]},
  { path: 'Drivers', component : DriversComponent,canActivate: [AuthGuard]},
  { path: 'Devices', component : DevicesComponent,canActivate: [AuthGuard]},
  { path: 'CustomerWiseInvoicesSummaryReport', component : CcPaymentReportComponent,canActivate: [AuthGuard]},
  { path: 'CustomerWiseSummaryReport', component : CustomerComponent,canActivate: [AuthGuard]},
  { path: 'Employee', component :EmployeeComponent ,canActivate: [AuthGuard]},
  { path: 'ContentManager', component : ContentManagementComponent,canActivate: [AuthGuard]},
  { path: 'Add-Edit-Employee', component: AddEmployeeComponent, canActivate: [AuthGuard]},
  // { path: 'referralSummary', component : ReferralSummaryComponent, canActivate: [AuthGuard]},



];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
